import React from 'react';
import { ServiceFeaturesGrid } from '../common/service-features-grid';

export function EnterpriseSoftwareServies() {
    const features = [
        {
            title: 'Enterprise Mobility Solutions',
            description:
                'Transform your business with our mobile expertise. Our skilled developers boost productivity and engagement by optimizing processes and securing data. Make the most of intuitive interfaces, seamless access, and safe data transfer.',
            icon: '/img/technology/ic-mobility.svg',
        },
        {
            title: 'Enterprise Software Integration',
            description:
                'We provide enterprise application integration services to help departments bridge departmental gaps. Using our enterprise systems integration, we enable real-time data flow and efficient workflows within your organization.',
            icon: '/img/technology/ic-integration-enterprise.svg',
        },
        {
            title: 'Enterprise Cloud Solution',
            description:
                'With our enterprise cloud solution, you can embrace growth. Our team migrates, deploys, and manages apps and infrastructure to maximize cost-efficiency and scalability. With cloud computing, you can drive innovation and agility.',
            icon: '/img/technology/ic-cloud-solution.svg',
        },
        {
            title: 'Software Testing and QA Consulting',
            description:
                'Our testing and QA services ensure top-quality, Whether it\'s a new application or an update. We use advanced tools and methods to identify issues, optimize performance, and enhance the user experience.',
            icon: '/img/technology/ic-testing-qa-consulting.svg',
        },
        {
            title: 'Enterprise Software Maintenance and Support',
            description:
                'Our comprehensive software maintenance services guarantee optimal performance by closely monitoring your system, quickly resolving any issues that arise, and ensuring that your software is always up-to-date with the latest advancements.',
            icon: '/img/technology/ic-maintenance-support.svg',
        },
        {
            title: 'Enterprise Data Management',
            description:
                'Being a top enterprise software development firm, we believe strong data management is vital for business success. We help you keep your data organized, clean, and secure, tailored to your needs while streamlining processes, reducing errors, and boosting security.',
            icon: '/img/technology/ic-data-management.svg',
        },
        {
            title: 'Legacy Application Modernization',
            description:
                'We modernize legacy software, using cutting-edge technologies and zero data loss during migration to ensure its effectiveness, reliability, and security. Also, we stay updated with tech trends and suggest replacements for outdated systems.',
            icon: '/img/technology/ic-application-modernization.svg',
        },
        {
            title: 'Software Product Development',
            description:
                'We develop engaging software products that provide a remarkable customer experience. We use industry-leading software development solutions and dedicate a team of technical and business experts to each project to ensure market success.',
            icon: '/img/technology/ic-product-development.svg',
        },
        {
            title: 'Enterprise Software Consulting',
            description:
                'We work with you to understand your needs and challenges and to find the right technology to meet your operational and financial goals. Our software consultants have expertise in emerging technologies such as AI, blockchain, IoT, and cloud computing.',
            icon: '/img/technology/ic-consulting.svg',
        },
    ];

    return (
        <>
            <div className="section-py bg-grey dark:bg-black">
                <div className="container lg:container mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                            <p
                                className="text-primary mb-0 fs-lg fw-700"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="200"
                            >
                                We Provide
                            </p>
                            <h2
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="100"
                            >
                                Enterprise Software Development Services
                            </h2>
                        </div>
                    </div>
                <ServiceFeaturesGrid 
                    features={features} 
                    variant="grey"
                />
                </div>
            </div>
        </>
    );
}

export default EnterpriseSoftwareServies;
